import { FaUserCircle } from 'react-icons/fa';

import { FLButton } from '@shared/ui';

import { logout } from '@entities/user';
import { useAppDispatch } from '@shared/model/hooks';
import { buttonClasses } from './Button.tailwind';

const LogoutButton = () => {
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <FLButton
      type="primary"
      text="Logout"
      classes={buttonClasses}
      icon={<FaUserCircle />}
      onClick={handleLogout}
      data-id="button-Logout"
    />
  );
};

export default LogoutButton;
